<div class="content dark">
	<div class="row">
		<div class="col-lg-6">
			<div class="form-group">
				<label>Organization to assign configuration to:</label>
				<select [(ngModel)]="selectedOrganization" class="form-control">
					<option *ngFor="let org of organizations" [ngValue]="org">{{org.name}}</option>
				</select>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-lg-12">
			<div class="form-group">
				<label>New Config XML:</label>
				<div>
					<textarea [(ngModel)]="newConfig" style="width: 100%;height: 400px;"></textarea>
				</div>
			</div>
			<app-action-button [action]="UploadConfig" [context]="this" processing="Uploading..." complete="Config added">Add
				Config</app-action-button>
		</div>
	</div>
</div>